import axiosClient from "../axios/axiosClient";

export function getResearchAreas() {
  return axiosClient.get("/research-areas");
}

export function getResearchArea(researchAreaId) {
  return axiosClient.get(`/research-areas/${researchAreaId}`);
}

export function createResearchArea(data) {
  return axiosClient.post("/research-areas", data);
}

export const updateResearchArea = (researchAreaId, data) => {
  return axiosClient.put(`/research-areas/${researchAreaId}`, data);
};

export function deleteResearchArea(researchAreaId) {
  return axiosClient.delete(`/research-areas/${researchAreaId}`);
}
